"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BNSApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class BNSApi extends runtime.BaseAPI {
    /**
     * Fetch a user’s raw zone file. This only works for RFC-compliant zone files. This method returns an error for names that have non-standard zone files.
     * Fetch Zone File
     */
    async fetchZoneFileRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling fetchZoneFile.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/names/{name}/zonefile`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Fetch a user’s raw zone file. This only works for RFC-compliant zone files. This method returns an error for names that have non-standard zone files.
     * Fetch Zone File
     */
    async fetchZoneFile(requestParameters, initOverrides) {
        const response = await this.fetchZoneFileRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Fetch a list of all names known to the node.
     * Get All Names
     */
    async getAllNamesRaw(requestParameters, initOverrides) {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling getAllNames.');
        }
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/names`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Fetch a list of all names known to the node.
     * Get All Names
     */
    async getAllNames(requestParameters, initOverrides) {
        const response = await this.getAllNamesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Fetch a list of all namespaces known to the node.
     * Get All Namespaces
     */
    async getAllNamespacesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/namespaces`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.BnsGetAllNamespacesResponseFromJSON(jsonValue));
    }
    /**
     * Fetch a list of all namespaces known to the node.
     * Get All Namespaces
     */
    async getAllNamespaces(initOverrides) {
        const response = await this.getAllNamespacesRaw(initOverrides);
        return await response.value();
    }
    /**
     * Fetch a list of all subdomains known to the node.
     * Get All Subdomains
     */
    async getAllSubdomainsRaw(requestParameters, initOverrides) {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling getAllSubdomains.');
        }
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/subdomains`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Fetch a list of all subdomains known to the node.
     * Get All Subdomains
     */
    async getAllSubdomains(requestParameters, initOverrides) {
        const response = await this.getAllSubdomainsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Fetches the historical zonefile specified by the username and zone hash.
     * Get Historical Zone File
     */
    async getHistoricalZoneFileRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getHistoricalZoneFile.');
        }
        if (requestParameters.zoneFileHash === null || requestParameters.zoneFileHash === undefined) {
            throw new runtime.RequiredError('zoneFileHash', 'Required parameter requestParameters.zoneFileHash was null or undefined when calling getHistoricalZoneFile.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/names/{name}/zonefile/{zoneFileHash}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"zoneFileHash"}}`, encodeURIComponent(String(requestParameters.zoneFileHash))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Fetches the historical zonefile specified by the username and zone hash.
     * Get Historical Zone File
     */
    async getHistoricalZoneFile(requestParameters, initOverrides) {
        const response = await this.getHistoricalZoneFileRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a history of all blockchain records of a registered name.
     * Get Name History
     */
    async getNameHistoryRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getNameHistory.');
        }
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling getNameHistory.');
        }
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/names/{name}/history`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a history of all blockchain records of a registered name.
     * Get Name History
     */
    async getNameHistory(requestParameters, initOverrides) {
        const response = await this.getNameHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Name Details
     */
    async getNameInfoRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getNameInfo.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/names/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.BnsGetNameInfoResponseFromJSON(jsonValue));
    }
    /**
     * Get Name Details
     */
    async getNameInfo(requestParameters, initOverrides) {
        const response = await this.getNameInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get the price of a name. The `amount` given will be in the smallest possible units of the currency.
     * Get Name Price
     */
    async getNamePriceRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getNamePrice.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v2/prices/names/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.BnsGetNamePriceResponseFromJSON(jsonValue));
    }
    /**
     * Get the price of a name. The `amount` given will be in the smallest possible units of the currency.
     * Get Name Price
     */
    async getNamePrice(requestParameters, initOverrides) {
        const response = await this.getNamePriceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Retrieves a list of names owned by the address provided.
     * Get Names Owned by Address
     */
    async getNamesOwnedByAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.blockchain === null || requestParameters.blockchain === undefined) {
            throw new runtime.RequiredError('blockchain', 'Required parameter requestParameters.blockchain was null or undefined when calling getNamesOwnedByAddress.');
        }
        if (requestParameters.address === null || requestParameters.address === undefined) {
            throw new runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling getNamesOwnedByAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/addresses/{blockchain}/{address}`.replace(`{${"blockchain"}}`, encodeURIComponent(String(requestParameters.blockchain))).replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.BnsNamesOwnByAddressResponseFromJSON(jsonValue));
    }
    /**
     * Retrieves a list of names owned by the address provided.
     * Get Names Owned by Address
     */
    async getNamesOwnedByAddress(requestParameters, initOverrides) {
        const response = await this.getNamesOwnedByAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Fetch a list of names from the namespace.
     * Get Namespace Names
     */
    async getNamespaceNamesRaw(requestParameters, initOverrides) {
        if (requestParameters.tld === null || requestParameters.tld === undefined) {
            throw new runtime.RequiredError('tld', 'Required parameter requestParameters.tld was null or undefined when calling getNamespaceNames.');
        }
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling getNamespaceNames.');
        }
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/namespaces/{tld}/names`.replace(`{${"tld"}}`, encodeURIComponent(String(requestParameters.tld))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Fetch a list of names from the namespace.
     * Get Namespace Names
     */
    async getNamespaceNames(requestParameters, initOverrides) {
        const response = await this.getNamespaceNamesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get the price of a namespace. The `amount` given will be in the smallest possible units of the currency.
     * Get Namespace Price
     */
    async getNamespacePriceRaw(requestParameters, initOverrides) {
        if (requestParameters.tld === null || requestParameters.tld === undefined) {
            throw new runtime.RequiredError('tld', 'Required parameter requestParameters.tld was null or undefined when calling getNamespacePrice.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v2/prices/namespaces/{tld}`.replace(`{${"tld"}}`, encodeURIComponent(String(requestParameters.tld))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.BnsGetNamespacePriceResponseFromJSON(jsonValue));
    }
    /**
     * Get the price of a namespace. The `amount` given will be in the smallest possible units of the currency.
     * Get Namespace Price
     */
    async getNamespacePrice(requestParameters, initOverrides) {
        const response = await this.getNamespacePriceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Fetches the list of subdomain operations processed by a given transaction. The returned array includes subdomain operations that have not yet been accepted as part of any subdomain’s history (checkable via the accepted field). If the given transaction ID does not correspond to a Blockstack transaction that introduced new subdomain operations, and empty array will be returned.
     * Get Subdomain at Transaction
     */
    async getSubdomainAtTransactionRaw(requestParameters, initOverrides) {
        if (requestParameters.txid === null || requestParameters.txid === undefined) {
            throw new runtime.RequiredError('txid', 'Required parameter requestParameters.txid was null or undefined when calling getSubdomainAtTransaction.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/subdomains/{txid}`.replace(`{${"txid"}}`, encodeURIComponent(String(requestParameters.txid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.InlineResponse200FromJSON));
    }
    /**
     * Fetches the list of subdomain operations processed by a given transaction. The returned array includes subdomain operations that have not yet been accepted as part of any subdomain’s history (checkable via the accepted field). If the given transaction ID does not correspond to a Blockstack transaction that introduced new subdomain operations, and empty array will be returned.
     * Get Subdomain at Transaction
     */
    async getSubdomainAtTransaction(requestParameters, initOverrides) {
        const response = await this.getSubdomainAtTransactionRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
exports.BNSApi = BNSApi;
//# sourceMappingURL=BNSApi.js.map